export default __webpack_public_path__ + "static/sculptor-5fee7018b9ff3fe6cc3de96e18f68ea6.gif";